import { Coordinates } from '@shared/types/ContactDetail';
import { GeoPoint } from '@shared/helper/GeoPoint';
import { clientZipcodeAndCity } from './ClientZipcodeAndCity';

export class Geolocation {
  public static coordinates: Coordinates = {
    latitude: 0,
    longitude: 0,
  };

  private static onSuccessPromise: Promise<void> | null = null;
  private static isBrowserEnabled = false;

  static init(fallbackLatitude: number, fallbackLongitude: number) {
    this.coordinates = { latitude: fallbackLatitude, longitude: fallbackLongitude };
    if (!import.meta.env.SSR && !this.onSuccessPromise) {
      this.onSuccessPromise = new Promise<void>((resolve) => {
        window.navigator.geolocation.getCurrentPosition(
          (position) => {
            this.onSuccess(position);
            resolve();
          },
          () => resolve()
        );
      });
    }
  }

  private static onSuccess = ({ coords }: GeolocationPosition) => {
    this.isBrowserEnabled = true;
    const { latitude, longitude } = coords;
    this.coordinates = { latitude, longitude };
  };

  static async getZipcodeAndCity(): Promise<string | void> {
    // const loader = new Loader({
    //   apiKey: this.apiKey,
    //   version: 'weekly',
    // });
    // const google = await loader.load();
    // await this.onSuccessPromise;

    // try {
    //   const geocoder = new google.maps.Geocoder();
    //   const { results } = await geocoder.geocode({
    //     location: {
    //       lat: this.coordinates.latitude,
    //       lng: this.coordinates.longitude,
    //     },
    //   });
    //   return clientZipcodeAndCity(results);
    // } catch (e) {
    //   Bugsnag.notify(e as NotifiableError);
    // }
    clientZipcodeAndCity([]);
  }

  static isBrowserLocationEnabled(): boolean {
    return this.isBrowserEnabled;
  }

  static async calculate(destination: Coordinates): Promise<number> {
    await this.onSuccessPromise;
    return new GeoPoint().calculateDistanceInKm(
      { latitude: this.coordinates.latitude, longitude: this.coordinates.longitude },
      { latitude: destination?.latitude, longitude: destination?.longitude }
    );
  }
}
